<template>
  <div class="category-sort">
    <button @click="openMobileFilters()" class="dropdown__toggle  dropdown__toggle--filter" type="button">
      {{ in18['page_filters'] }}
    </button>
    <div class="dropdown  dropdown--sort">
      <button aria-expanded="false" aria-haspopup="true" class="dropdown__toggle" data-bs-toggle="dropdown"
              type="button">
        {{ in18['page_per_page'] }}
      </button>
      <ul class="dropdown-menu  dropdown-menu-end">
        <li>
          <a title="16" class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('per_page', '16')">
            16
          </a>
        </li>
        <li>
          <a title="32"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('per_page', '32')">
            32
          </a>
        </li>
        <li>
          <a title="48"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('per_page', '48')">
            48
          </a>
        </li>
      </ul>
    </div>
    <div class="dropdown  dropdown--sort">
      <button aria-expanded="false" aria-haspopup="true" class="dropdown__toggle" data-bs-toggle="dropdown"
              type="button">
        {{ in18['page_sort_by'] }}
      </button>
      <ul class="dropdown-menu  dropdown-menu-end">
        <li>
          <a :title="in18['page_largest_number']" class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'quantity:desc')">
            {{ in18['page_largest_number'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_smallest_quantity']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'quantity:asc')">
            {{ in18['page_smallest_quantity'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_newest_first']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'created_at:desc')">
            {{ in18['page_newest_first'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_oldest_first']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'created_at:asc')">
            {{ in18['page_oldest_first'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_by_name_a_z']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'title:asc')">
            {{ in18['page_by_name_a_z'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_by_name_z_a']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'title:desc')">
            {{ in18['page_by_name_z_a'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_lowest_prices_first']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'price_with_tax:asc')">
            {{ in18['page_lowest_prices_first'] }}
          </a>
        </li>
        <li>
          <a :title="in18['page_highest_prices_first']"
             class="dropdown-menu__link"
             href="javascript:void(0)"
             @click="changeFilter('sort', 'price_with_tax:desc')">
            {{ in18['page_highest_prices_first'] }}
          </a>
        </li>
      </ul>
    </div>
    <ul class="category-sort__list  category-sort__list--grid">
      <li>
        <button :class="{ 'active': display === 'grid' }" class="category-sort__list-btn  category-sort__list-btn--grid"
                type="button"
                @click="setDisplay('grid')">
        </button>
      </li>
      <li>
        <button :class="{ 'active': display === 'row' }" class="category-sort__list-btn  category-sort__list-btn--list"
                type="button"
                @click="setDisplay('row')">
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name:    "catalogSort",
  props:   {
    in18:    Object,
    display: String,
  },
  emits:   [
    'changeFilter',
    'displayChanged'
  ],
  methods: {
    changeFilter(prop, value) {
      this.$emit('changeFilter', prop, value);
    },
    setDisplay(display) {
      this.$emit('displayChanged', display);
    },
    openMobileFilters(){
      this.$store.dispatch('setFilters', true)
    }
  },
};
</script>
